module.exports = __webpack_public_path__ + "static/media/ContactCloudBannerDesktop.56174653.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/ContactCloudBannerDesktop.svg
// module id = 637
// module chunks = 0